var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.415649 2C0.415649 0.895431 1.33067 0 2.4594 0H8.59065C9.71938 0 10.6344 0.895431 10.6344 2V18C10.6344 19.1046 9.71938 20 8.59065 20H2.4594C1.33067 20 0.415649 19.1046 0.415649 18V2ZM1.43752 3V17H9.61253V3H1.43752ZM3.48127 1.5C3.48127 1.22386 3.71003 1 3.99221 1H7.05784C7.34002 1 7.56878 1.22386 7.56878 1.5C7.56878 1.77614 7.34002 2 7.05784 2H3.99221C3.71003 2 3.48127 1.77614 3.48127 1.5ZM4.74839 18.5C4.74839 18.0858 5.09152 17.75 5.5148 17.75C5.93807 17.75 6.2812 18.0858 6.2812 18.5C6.2812 18.9142 5.93807 19.25 5.5148 19.25C5.09152 19.25 4.74839 18.9142 4.74839 18.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.1f99398415c7cd6e36e309706cfc981b.svg";
export { ForwardRef as ReactComponent };